import { cn } from '@/lib/utils';
import { LeafLeft, LeafRight } from './LaurelLeaves';
export default function HeroStats({
  stats,
  className,
}: {
  stats?: { value: string; label: string }[];
  className?: string;
}) {
  if (!stats?.length) return null;

  return (
    <div
      className={cn(
        'flex items-center  lg:flex-row flex-col lg:gap-[1rem] gap-[3rem] justify-between lg:py-[4.62rem] lg:px-[7rem] px-[2rem] lg:border-[.125rem] border-[#e5e5e5] flex-wrap w-[min(165.5rem,100%)]',
        className,
      )}
    >
      {stats.map(({ value, label }) => (
        <div
          key={value + label}
          className="flex gap-[1.75rem] lg:w-auto w-fit items-end shrink-0"
        >
          <LeafLeft className="w-[4.125rem] h-[6rem] shrink-0" />
          <div className="flex flex-col gap-[0.5rem] items-center justify-center text-center whitespace-nowrap">
            <p className="font-semibold leading-[1.12] text-[#103037] text-[3.25rem] tracking-[-0.0975rem] mb-0">
              {value}
            </p>
            <p className="font-normal leading-[1.2] text-[#414141] text-[2rem] mb-0">
              {label}
            </p>
          </div>
          <LeafRight className="w-[4.125rem] h-[6rem] shrink-0" />
        </div>
      ))}
    </div>
  );
}
